// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"8549a6c3","85":"997c71bd","121":"40b47b67","151":"8121d16d","323":"eb523b01","338":"3efd38cd","456":"cd66f86d","541":"02f1116b","542":"5a6163da","544":"a4c36d58","576":"f67a2322","611":"d1efc564","753":"e52cf182","775":"8f54c00a","823":"cf85265a","890":"f376c87b"}[chunkId] + ".js";
};